import React from 'react';
import LandingPage from './pages/LandingPage';

/**
 * Le site est désormais une landing page unique présentant les ateliers
 * de Yoga pour Arts Martiaux et de Méditation à Parenthèse Holistique.
 *
 * L'ancienne application de réservation (pages, composants, store, API)
 * est conservée dans le dépôt mais n'est plus montée ici.
 */
function App() {
  return <LandingPage />;
}

export default App;
